import React from 'react';

/* Entonnoir — ouvre la zone 5 (filtres) de la toolbar : on reconnaît d'un coup
   d'œil la ligne qui RESTREINT ce qu'on lit. */
export default function FilterIcon() {
  return (
    <svg className="lk-cs__tb-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
    </svg>
  );
}
